import * as Yup from 'yup';
import { useState, useContext, useEffect, useReducer } from 'react';
import { useSearchParams } from 'react-router-dom';
//
import { useSnackbar } from 'notistack5';
import { useFormik, Form, FormikProvider } from 'formik';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
//
import moment from 'moment';
// material
import { Close } from '@material-ui/icons';
import { makeStyles, createStyles } from '@material-ui/styles';
import {
  Stack,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  FormControl,
  IconButton,
  Divider,
  Box, Autocomplete,
  Typography,
  OutlinedInput, Chip
} from '@material-ui/core';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker, TimePicker } from '@mui/x-date-pickers';
// hooks
import { useDispatch, useSelector } from 'react-redux';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
//
import { MIconButton } from '../../../../components/@material-extend';
import ScoreCardsContext from '../../../../contexts/ScoreCardsContext';
import { AnalyticContext } from '../../../../contexts/AnalyticContext';
import { SettingsContext } from "../../../../contexts/SettingsContext"
import { handleTeamFilterData } from '../../../../redux/slices/AnalyticsSlices/TeamFilterSlice';

// ----------------------------------------------------------------------

const useStyles = makeStyles(() => ({
  dropdownListStyle: {
    padding: 5
  },
  select: {
    backgroundColor: '#FFFFFF'
  },
  selectDisabled: {
    backgroundColor: '#E9ECEF'
  },
  textField: {
    backgroundColor: '#FFFFFF'
  },
  textFieldLock: {
    backgroundColor: '#E9ECEF'
  },
  selectLock: {
    backgroundColor: '#E9ECEF'
  }
}));

const formulaType = [
  {
    id: 10,
    type: 'True'
  },
  {
    id: 20,
    type: 'Potential'
  }
]
// ----------------------------------------------------------------------

export default function AnalyticsTeamsFilterDialog({
  addUserButton,
  setAddMode,
  closeAddUserDialog,
}) {

  const [searchParams, setSearchParams] = useSearchParams()
  const dateRange = [
    {
      id: 1,
      dateRange: 'Today'
    },
    {
      id: 2,
      dateRange: 'Yesterday'
    },
    {
      id: 3,
      dateRange: 'This Week'
    },
    {
      id: 4,
      dateRange: 'Last Week'
    },
    {
      id: 5,
      dateRange: 'This Month'
    },
    {
      id: 6,
      dateRange: 'Last Month'
    },
    {
      id: 7,
      dateRange: 'This Quarter'
    },
    {
      id: 8,
      dateRange: 'Last Quarter'
    },
    {
      id: 9,
      dateRange: 'This Year'
    },
    {
      id: 10,
      dateRange: 'Last Year'
    },
    {
      id: 11,
      dateRange: 'Custom Date Range'
    }
  ];

  const filterBy = [
    {
      id: 1,
      type: 'Score Date'
    },
    {
      id: 2,
      type: 'Event Date'
    },
    {
      id: 3,
      type: 'Last Edit Date'
    }
  ];

  const getWeekDay = (date) => {
    if (date !== undefined && date !== "") {
      const weeknumber = moment(date, "YYYY-MM-DD").isoWeek();
      return weeknumber;
    }
    return ""
  };

  // const { userLevels, groups, teams, getUserLevels, getGroups, getTeams, addUser, getAllUsers, editUser, resetPassword } = useContext(AddUserContext);
  const {
    getScoreLogGroups,
    getScoreLogScorecards,
    getScoreLogTeams,
    getScoreLogEmployee,
    getSectionDropdown,
    reportsScoreLogGroups,
    getScoreLogEventType,
    reportsScoreLogEventType,
    getScoreLogEventSubType,
    reportsScoreLogEventSubType,
    reportsScoreLogScorecards,
    reportsScoreLogEmployee,
    scorecardSection,
    reportsScoreLogTeams,
    reportsScoreLogSupervisor,
    loadingState,
    getScoreLogSupervisor
  } = useContext(ScoreCardsContext);
  const {
    subModLabel,
    getPointsOfFailureByTeam, dateTypeSecTrend,
    setSelAnaTeamsFilters, setIsLoadingTeams,
    selectedTeamsGroupFilter, setSelectedTeamsGroupFilter,
    selectedDateAnaTeamsRange, setSelectedDateAnaTeamsRange,
    selectedTeamsFromDate, setSelectedTeamsFromDate,
    selectedTeamsToDate, setSelectedTeamsToDate,
    selectedTeamsHighlight, setSelectedTeamsHighlight,
    selectedTeamsFilterByValue, setSelectedTeamsFilterByValue,
    selectedTeamsFilterBy, setSelectedTeamsFilterBy, setSelectedTeamsEventFilter,
    setSelectedTeamsEventSubTypeFilter,
    selectedTeamsEventFilter, getOverAllTeamTrend, getStaffTrendBySupervisor,
    selectedTeamsEventSubTypeFilter, getTeamSupervisorList,
    selectedTeamsFromWeek, setSelectedTeamsFromWeek,
    selectedTeamsToWeek, setSelectedTeamsToWeek,
    getQuestionTrendByIndividualTeam,
    getSectionTrendByTeam,
    // multipleScoreCard, setMultipleScoreCard,
    singleScoreCard, setSingleScoreCard,
    getDataTagsByScoreCard, setselectedDataTagFilter,
    dataTagByScoreCard, setselectedDataTag,
    setDataTagByScoreCard,
    setSelectedTeamStaffFilter, selectedTeamStaffFilter,
    setSelectedSelectionFilter,
    setSelectedTeamsSupervisorFilter,
    selectedTeamsSupervisorFilter,
    selectedTeamFilterDialog, setSelectedTeamFilterDialog
  } = useContext(AnalyticContext);

  const { showSidebar, setShowSidebar, dataCreatedFrom, setDataCreatedFrom } = useContext(SettingsContext);

  const [open, setOpen] = useState(false);

  const [advanceFilters, setAdvanceFilters] = useState();
  const [customFilters, setCustomFilters] = useState(false);
  const [fromWeekNo, setFromWeekNo] = useState([]);
  const [toWeekNo, setToWeekNo] = useState([]);

  const newDispatch = useDispatch()
  const isMountedRef = useIsMountedRef();
  const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));

  const filterFieldsData = useSelector(state => state.teamFilterFields.teamFilterData)
  // console.log('Team module', filterFieldsData)

  const initialState = {
    openGroupField: false,
    openSingleScorecardField: false,
    openMultiScorecardField: false,
    openEventTypeField: false,
    openEventSubTypeField: false,
    openTeamField: false,
    openSupervisorField: false,
    openStaffField: false,
    openSectionField: false,
    openQuestionField: false,
    openEvalField: false,

  }

  const reducerFunc = (state, action) => {
    // console.log('state ==>', state, action)
    switch (action.type) {
      case 'SET_VALUE':
        return { ...state, ...action.payload };
      case 'RESET_VALUE':
        return initialState;
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducerFunc, initialState)

  // helper function to update state value--
  const updateState = (key, value) => {
    dispatch({ type: 'SET_VALUE', payload: { [key]: value } });
  };

  // helper function to reset the state
  const resetState = (key, value) => {
    dispatch({ type: 'RESET_VALUE' });
  };


  useEffect(() => {
    if (open) {
      if (filterFieldsData?.dateRange) {
        setFieldValue('dateRange', filterFieldsData?.dateRange);
        setFieldValue('fromDate', filterFieldsData?.fromDate);
        setFieldValue('toDate', filterFieldsData?.toDate);
      } else {
        setFieldValue('dateRange', 'This Month');
        setFieldValue('fromDate', moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('month').format('YYYY-MM-DD'));
      }

      if (filterFieldsData?.dateRange === 'Custom Date Range') {
        setCustomFilters(true);
        setFieldValue('fromDate', filterFieldsData?.fromDate);
        setFieldValue('toDate', filterFieldsData?.toDate);
        setFieldValue('fromWeek', filterFieldsData?.fromWeek)
        setFieldValue('toWeek', filterFieldsData?.toWeek)
      }

      if (filterFieldsData?.filterBy) {
        setFieldValue('filterByRange', filterFieldsData?.filterByRange);
        setFieldValue('filterBy', filterFieldsData?.filterBy);
      } else {
        setFieldValue('filterByRange', 'Score Date');
        setFieldValue('filterBy', 'created_at');
      }

      if (filterFieldsData?.group) {
        setFieldValue('group', filterFieldsData?.group);
      } else {
        setFieldValue('group', '');
      }

      if (filterFieldsData?.groupField) {
        setFieldValue("groupField", filterFieldsData?.groupField);
      } else {
        setFieldValue("groupField", {});
      }

      if (filterFieldsData?.teams) {
        setFieldValue('teams', filterFieldsData?.teams);
      } else {
        setFieldValue('teams', '');
      }

      if (filterFieldsData?.teamField) {
        setFieldValue("teamField", filterFieldsData?.teamField);
      } else {
        setFieldValue("teamField", { id: '', name: "All" });
      }

      // singleScoreCard
      if (filterFieldsData?.singleScoreCard) {
        setFieldValue('singleScoreCard', filterFieldsData?.singleScoreCard);
      } else {
        setFieldValue('singleScoreCard', '');
      }

      if ((filterFieldsData?.singleScorecardField ||
        filterFieldsData?.multiScorecardField?.length !== 0)) {
        if (filterFieldsData?.singleScorecardField) {

          setFieldValue("singleScorecardField", filterFieldsData?.singleScorecardField)
        } else if (filterFieldsData?.multiScorecardField) {
          setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])

        }
      } else {
        setFieldValue("singleScorecardField", {});
      }
      // multipleScorecard
      if (filterFieldsData?.multipleScoreCard) {
        setFieldValue('multipleScoreCard', filterFieldsData?.multipleScoreCard);
        setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])
      } else {
        setFieldValue('multipleScoreCard', []);
      }

      if (filterFieldsData?.multiScorecardField) {
        setFieldValue("multiScorecardField", filterFieldsData?.multiScorecardField);
        setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])

      } else {
        setFieldValue("multiScorecardField", []);
      }
      // selectedTeamStaffFilter
      if (filterFieldsData?.staff) {
        setFieldValue('staff', filterFieldsData?.staff);
      } else {
        setFieldValue('staff', '');
      }

      if (filterFieldsData?.staffField) {
        setFieldValue('staffField', filterFieldsData?.staffField)
      } else {
        setFieldValue("staffField", '');
        // setFieldValue("staffField", {
        //   staffUserFirstName: 'All',
        //   staffUserLastName: '',
        //   supervisor: ''
        // });
      }

      if (filterFieldsData?.eventType) {
        setFieldValue('eventType', filterFieldsData?.eventType);
      } else {
        setFieldValue('eventType', '');
      }

      if (filterFieldsData?.eventField) {
        setFieldValue("eventField", filterFieldsData?.eventField);
      } else {
        setFieldValue("eventField", {
          eventType: '',
          eventTypeEventType: "All",
          scoreCard: ''
        })
      }

      if (filterFieldsData?.eventTypeEventSubType) {
        setFieldValue('eventTypeEventSubType', filterFieldsData?.eventTypeEventSubType);
      } else {
        setFieldValue('eventTypeEventSubType', '');
      }

      if (filterFieldsData?.eventSubField) {
        setFieldValue("eventSubField", filterFieldsData?.eventSubField);
      } else {
        setFieldValue("eventSubField", {
          eventSubType: '',
          subType: "All",
          scorecard: ''
        })
      }

      if (filterFieldsData?.section) {
        setFieldValue('section', filterFieldsData?.section)
      } else {
        setFieldValue('section', '')

      }

      if (filterFieldsData?.sectionField) {
        setFieldValue('sectionField', filterFieldsData?.sectionField)
      } else {
        setFieldValue('sectionField', {
          id: '',
          name: 'All',
          scoreCard: '',
          type: ''
        })

      }

      if (filterFieldsData?.supervisor) {
        setFieldValue("supervisor", filterFieldsData?.supervisor);
      } else {
        setFieldValue("supervisor", '');
      }
      if (filterFieldsData?.supervisorField) {
        setFieldValue("supervisorField", filterFieldsData?.supervisorField);
      } else {
        setFieldValue("supervisorField", { supervisorUserFirstName: 'All', supervisorUserLastName: '', supervisor: '' });
      }


      if (filterFieldsData?.highlightValue) {
        setFieldValue('highlightValue', filterFieldsData?.highlightValue);
      } else {
        setFieldValue('highlightValue', '');
      }
    }
  }, [open]);

  const ReportSchema = Yup.object().shape({
    multipleScoreCard: (subModLabel === 5.4) ? Yup.number().transform((value) => Number.isNaN(value) ? null : value).required('This Value is required').nullable() : Yup.array().nullable(),
    singleScoreCard: (subModLabel === 5.3) ? Yup.number().required('This Value is required').nullable() : Yup.string().nullable(),
    staff: (subModLabel === 5.3) ? Yup.number().required('This Value is required').nullable() : Yup.string().nullable(),
    group: Yup.string().required('This Value is required')
  });

  const formik = useFormik({
    initialValues: {
      id: '',
      dateRange: '',
      filterByRange: '',
      fromDate: '',
      toDate: '',
      filterBy: '',
      group: '',
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: '',
      highlightValue: '',
      fromweekValue: '',
      toweekValue: '',
      teams: '',
      staff: '',
      reference: '',
      section: '',
      question: '',
      formula: 10,
      // teamsId: searchParams.get('teams__id') || '',
      allOfTag: '',
      anyOfTag: '',
      dataTag: [],
      singleScoreCard: '',
      multipleScoreCard: [],
      groupField: {},
      teamField: {},
      singleScorecardField: {},
      multiScorecardField: [],
      eventField: {},
      eventSubField: {},
      supervisorField: {},
      sectionField: {},
      questionField: {},
      evaluatorField: {},
      staffField: {}
    },
    validationSchema: ReportSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {

      try {
        // persist filtered values on refresh
        // localStorage.setItem("selectedDateAnaTeamsRange", JSON.stringify(selectedDateAnaTeamsRange || 'This Month'));
        // localStorage.setItem("selectedTeamsFilterBy", JSON.stringify(selectedTeamsFilterBy || 'Score Date'));
        // localStorage.setItem("selectedTeamsFilterByValue", JSON.stringify(selectedTeamsFilterByValue || "created_at"));
        // localStorage.setItem("selectedTeamsFromDate", JSON.stringify(selectedTeamsFromDate));
        // localStorage.setItem("selectedTeamsToDate", JSON.stringify(selectedTeamsToDate));
        // localStorage.setItem("selectedTeamsGroupFilter", JSON.stringify(selectedTeamsGroupFilter));
        // localStorage.setItem("selectedTeamsScorecardFilter", JSON.stringify(singleScoreCard));
        // localStorage.setItem("selectedTeamsMultiScorecardFilter", JSON.stringify(multipleScoreCard));
        // localStorage.setItem("selectedTeamsStaffFilter", JSON.stringify(selectedTeamStaffFilter));
        // localStorage.setItem("selectedTeamsEventFilter", JSON.stringify(selectedTeamsEventFilter));
        // localStorage.setItem("selectedTeamsEventSubTypeFilter", JSON.stringify(selectedTeamsEventSubTypeFilter));

        const teamFilterObj =
        {
          "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
          "toDate": moment(values.toDate).format('YYYY-MM-DD'),
          'fromWeek': values?.fromWeek,
          'toWeek': values?.toWeek,
          "filterBy": values.filterBy,
          'dateRange': values.dateRange,
          "group": values.group,
          "teams": values.teams,
          "scoreCardGroups": values?.group,
          'multipleScoreCard': values.multipleScoreCard, // for 5.4 module autoselection when 5.3 module filter apply
          'singleScoreCard': values.singleScoreCard,
          "eventType": values.eventType,
          "eventTypeEventSubType": values.eventTypeEventSubType,
          "staff": values.staff,
          "scoreCardCategory": values.scoreCardCategory,
          "page": "1",
          "filterName": "",
          "highlightValue": values.highlightValue,
          "flag": dateTypeSecTrend,
          "formula": values.formula,
          "reference": values.reference,
          "section": values.section,
          "supervisor": values.supervisor,
          "question": values.question,
          // "teamsId": values.teamsId,
          "filterByRange": values.filterByRange,
          "groupField": values.groupField,
          "teamField": values.teamField,
          'numericValues': values.numericValues || '',
          'dataTags': values?.dataTag || '',
          'dataTagsOperator': values.anyOfTag || values.allOfTag || '',
          "singleScorecardField": values.singleScorecardField,
          "multiScorecardField": values.multiScorecardField,
          "eventField": values?.eventField,
          "eventSubField": values.eventSubField,
          "supervisorField": values.supervisorField,
          "sectionField": values.sectionField,
          "questionField": values?.questionField,
          "evaluatorField": values?.evaluatorField,
          "staffField": values.staffField,
          "subModule": subModLabel

        }

        if (subModLabel === 5.1) {
          const filterObj =
          {
            "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
            "toDate": moment(values.toDate).format('YYYY-MM-DD'),
            "filterBy": values.filterBy,
            "group": values.group,
            "teams": values.teams,
            "scoreCardGroups": values?.group,
            "eventType": values.eventType,
            "eventTypeEventSubType": values.eventTypeEventSubType,
            "staff": values.staff,
            "scoreCardCategory": values.scoreCardCategory,
            "page": "1",
            "filterName": "",
            "highlightValue": values.highlightValue,
            "flag": dateTypeSecTrend === 'year' ? 'quarter' : dateTypeSecTrend,
            "formula": values.formula,
            "reference": values.reference,
            "section": values.section,
            "supervisor": values.supervisor,
            "question": values.question,
            // "teamsId": values.teamsId,
            "filterByRange": values.filterByRange

          }
          setIsLoadingTeams(true);
          // setSelAnaTeamsFilters(teamFilterObj);
          // setSearchParams(teamFilterObj)
          // localStorage.setItem("selAnaTeamsFilters", JSON.stringify({ ...teamFilterObj }));

          // redux thunk call
          const newFilterObj = {
            ...teamFilterObj,
            "flag": dateTypeSecTrend === 'year' ? 'quarter' : dateTypeSecTrend,

          }
          newDispatch(handleTeamFilterData(newFilterObj))
          await getOverAllTeamTrend(filterObj);
          handleClose();
        }
        if (subModLabel === 5.2) {

          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            filterBy: values.filterBy,
            group: values.group,
            scoreCardGroups: values.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            filterByRange: values.filterByRange,
          };
          // redux thunk call
          newDispatch(handleTeamFilterData(teamFilterObj))

          await getPointsOfFailureByTeam(filterObj);
          // setSelAnaTeamsFilters(filterObj);
          // localStorage.setItem("selAnaTeamsFilters", JSON.stringify({ ...filterObj }));
          handleClose();
        } else if (subModLabel === 5.11) {
          setIsLoadingTeams(true);
          // setSelAnaTeamsFilters(teamFilterObj);
          // setSearchParams(teamFilterObj)

          // redux thunk call
          newDispatch(handleTeamFilterData(teamFilterObj))
          await getTeamSupervisorList(teamFilterObj);
          handleClose();
        }
        else if (subModLabel === 5.12) {
          setIsLoadingTeams(true);
          // setSelAnaTeamsFilters(teamFilterObj);
          // setSearchParams(teamFilterObj)

          // redux thunk call
          newDispatch(handleTeamFilterData(teamFilterObj))

          await getStaffTrendBySupervisor(teamFilterObj);
          handleClose();
        }

        if (subModLabel === 5.3) {
          const filterObj = {
            'fromDate': moment(values.fromDate).format('YYYY-MM-DD'),
            'toDate': moment(values.toDate).format('YYYY-MM-DD'),
            'filterBy': values.filterBy,
            'filterByRange': values.filterByRange,
            'group': values.group,
            'teams': values.teams,
            'scoreCard': values.multipleScoreCard, // for 5.4 module autoselection when 5.3 module filter apply
            'singleScoreCard': values.singleScoreCard,
            'scoreCardGroups': values?.group,
            'eventType': values.eventType,
            'eventTypeEventSubType': values.eventTypeEventSubType,
            'staff': values.staff,
            // 'scoreCardCategory': values.scoreCardCategory,
            'page': '1',
            'filterName': '',
            'highlightValue': values.highlightValue,
            'flag': dateTypeSecTrend === 'quarter' ? 'year' : dateTypeSecTrend,
            'section': values.section || '',
            'question': values.question || '',
            'supervisor': values.supervisor || '',
            'numericValues': values.numericValues || '',
            'formula': values.formula || '',
            'dataTags': values?.dataTag || '',
            'dataTagsOperator': values.anyOfTag || values.allOfTag || ''
          };

          // setSelAnaTeamsFilters(filterObj);

          // redux thunk call
          const newFilterObj = {
            ...teamFilterObj,
            'flag': dateTypeSecTrend === 'quarter' ? 'year' : dateTypeSecTrend,

          }
          newDispatch(handleTeamFilterData(newFilterObj))

          await getQuestionTrendByIndividualTeam(filterObj);
          // localStorage.setItem("selAnaTeamsFilters", JSON.stringify({ ...filterObj }));
          handleClose();

        }
        // console.log('subModLabel', subModLabel)
        if (subModLabel === 5.4) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            filterBy: values.filterBy,
            group: values.group,
            scoreCard: values.multipleScoreCard,
            singleScoreCard: values?.singleScoreCard,
            scoreCardGroups: values.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            filterByRange: values.filterByRange,
            flag: dateTypeSecTrend,
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            teams: values.teams,
            supervisor: values.supervisor,
            numeric: values.numericValues || '',
            reference: values.reference,
            formula: values.formula,
            dataTag: values.dataTag || '',
            dataTagsOperator: values?.allOfTag || values?.anyOfTag || '10'

          };

          // redux thunk call
          newDispatch(handleTeamFilterData(teamFilterObj))

          await getSectionTrendByTeam(filterObj);
          // setSelAnaTeamsFilters(filterObj);
          // localStorage.setItem("selAnaTeamsFilters", JSON.stringify({ ...filterObj }));
          handleClose();

        }

      } catch (error) {
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: error.message });
        }
      }
    },
    enableReinitialze: true
  });

  const { errors, touched, values, setFieldValue, handleSubmit, isSubmitting, getFieldProps } = formik;

  // Open user dialog modal
  const handleClickOpen = () => {
    setOpen(true);
  };

  // Close user dialog modal
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);

      if (!setAddMode) {
        closeAddUserDialog(false);
      }
    }
  };

  const handleCloseFields = () => {
    updateState('openGroupField', false)
    updateState('openSingleScorecardField', false)
    updateState('openMultiScorecardField', false)
    updateState('openEventTypeField', false)
    updateState('openEventSubTypeField', false)
    updateState('openTeamField', false)
    updateState('openSupervisorField', false)
    updateState('openStaffField', false)
    updateState('openSectionField', false)
    updateState('openQuestionField', false)
    updateState('openEvalField', false)

  };


  useEffect(() => {

    if (open) {
      const arrFromWeek = [];
      const arrToWeek = [];
      if (formik.values.fromWeek > moment().week()) {
        for (let i = 1; i <= formik.values.fromWeek; i) {
          arrFromWeek.push(i);
          i += 1;
        }
        setFromWeekNo(arrFromWeek);
      } else {
        for (let i = 1; i <= moment().week(); i) {
          arrFromWeek.push(i);
          i += 1;
        }
        setFromWeekNo(arrFromWeek);
      }

      if (formik.values.toWeek > moment().week()) {
        for (let i = 1; i <= formik.values.toWeek; i) {
          arrToWeek.push(i);
          i += 1;
        }
        setToWeekNo(arrToWeek);
      } else {
        for (let i = 1; i <= moment().week(); i) {
          arrToWeek.push(i);
          i += 1;
        }
        setToWeekNo(arrToWeek);
      }
    }

    // const groupFilterObj = {
    //   fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
    //   toDate: moment(values.toDate).format('YYYY-MM-DD'),
    //   filterBy: values.filterBy,
    //   group: '',
    //   eventType: values.eventType,
    //   eventTypeEventSubType: values.eventTypeEventSubType,
    //   highlightValue: values.highlightValue,
    //   sup_grp:
    //     loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
    //       ? loggedUserData?.groups?.map((obj) => obj.id)
    //       : ''
    // };

    // const evntTypeFilterObj =
    // {
    //   "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
    //   "toDate": moment(values.toDate).format('YYYY-MM-DD'),
    //   "filterBy": values.filterBy,
    //   "group": values.group,
    //   "eventType": '',
    //   "eventTypeEventSubType": '',
    //   "highlightValue": '',
    //   "teams": '',
    //   "scoreCard": '',
    //   "evaluator": '',
    //   "staff": '',
    //   "scoreCardCategory": '',
    //   "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    // }

    // const evntSubTypeFilterObj =
    // {
    //   "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
    //   "toDate": moment(values.toDate).format('YYYY-MM-DD'),
    //   "filterBy": values.filterBy,
    //   "group": values.group,
    //   "eventType": values.eventType,
    //   "eventTypeEventSubType": '',
    //   "highlightValue": '',
    //   "teams": '',
    //   "scoreCard": '',
    //   "evaluator": '',
    //   "staff": '',
    //   "scoreCardCategory": '',
    //   "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    // }
    // const scoreCardfilterObj =
    // {
    //   "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
    //   "toDate": moment(values.toDate).format('YYYY-MM-DD'),
    //   "filterBy": values.filterBy,
    //   "group": values.group,
    //   "teams": values.teams,
    //   "scoreCard": '',
    //   "eventType": '',
    //   "eventTypeEventSubType": '',
    //   "supervisor": '',
    //   "staff": '',
    //   "scoreCardCategory": '',
    //   "evaluator": '',
    //   "highlightValue": '',
    //   "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    // }
    // const teamFilterObj =
    // {
    //   "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
    //   "toDate": moment(values.toDate).format('YYYY-MM-DD'),
    //   "filterBy": values.filterBy,
    //   "group": values.group,
    //   "teams": values.teams,
    //   "scoreCard": '',
    //   "eventType": '',
    //   "eventTypeEventSubType": '',
    //   "supervisor": '',
    //   "staff": '',
    //   "scoreCardCategory": '',
    //   "evaluator": '',
    //   "highlightValue": '',
    //   "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    // }
    // const empFilterObj =
    // {
    //   "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
    //   "toDate": moment(values.toDate).format('YYYY-MM-DD'),
    //   "filterBy": values.filterBy,
    //   "group": values.group,
    //   "teams": values.teams,
    //   "scoreCard": (subModLabel === 5.4) ? values.multipleScoreCard : values.singleScoreCard,
    //   "eventType": values.eventType,
    //   "eventTypeEventSubType": values.eventTypeEventSubType,
    //   "supervisor": '',
    //   "staff": '',
    //   "scoreCardCategory": '',
    //   "evaluator": '',
    //   "highlightValue": '',
    //   "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    // }
    // if (formik.values.fromDate && formik.values.toDate && formik.values.filterBy) {
    //   getScoreLogGroups(groupFilterObj);
    //   getScoreLogEventType(evntTypeFilterObj);
    //   getScoreLogEventSubType(evntSubTypeFilterObj);
    //   getScoreLogScorecards(scoreCardfilterObj)
    //   getScoreLogTeams(teamFilterObj);
    //   getScoreLogEmployee(empFilterObj);
    //   if (subModLabel === '5.3') {
    //     getSectionDropdown(values?.singleScoreCard);
    //   }

    // }
  }, [formik?.values]);

  const handleDateRangeChange = (event) => {
    // Resetting remaining fields
    setFieldValue('group', '');
    setFieldValue('teams', '');
    setFieldValue('scoreCard', '');
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');
    setFieldValue('multipleScoreCard', []);

    // redux state fields
    setFieldValue('groupField', {});
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("staffField", '');
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });

    const dateRange = event.target.value;
    setFieldValue('dateRange', dateRange);
    switch (dateRange) {
      case 'Today':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('Today');
        break;
      case 'Yesterday':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('Yesterday');
        break;
      case 'This Week':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().startOf('week').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('week').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().startOf('week').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().endOf('week').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('This Week');
        break;
      case 'Last Week':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('Last Week');
        break;
      case 'This Month':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().startOf('month').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('This Month');
        break;
      case 'Last Month':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('Last Month');
        break;
      case 'This Quarter':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('This Quarter');
        break;
      case 'Last Quarter':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('Last Quarter');
        break;
      case 'This Year':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().startOf('year').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().startOf('year').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('This Year');
        break;
      case 'Last Year':
        setCustomFilters(false);
        setFieldValue('fromDate', moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'));
        setSelectedTeamsFromDate(moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'));
        setSelectedTeamsToDate(moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'));
        setSelectedDateAnaTeamsRange('Last Year');
        break;
      case 'Custom Date Range':
        setCustomFilters(true);
        setFieldValue('fromDate', moment());
        setFieldValue('toDate', moment());

        setSelectedTeamsFromDate(moment());
        setSelectedTeamsToDate(moment());

        if (moment().format('MM-DD') === '01-01') {
          setFieldValue("fromWeek", 1)
          setSelectedTeamsFromWeek(1);
        }
        else {
          setFieldValue("fromWeek", moment().year(moment().format('YYYY')).week());
          setSelectedTeamsFromWeek(moment().year(moment().format('YYYY')).week());
        }
        if (moment().format('MM-DD') === '01-01') {
          setFieldValue("toWeek", 1)
          setSelectedTeamsToWeek(1)
        }
        else {
          setFieldValue("toWeek", moment().year(moment().format('YYYY')).week());
          setSelectedTeamsToWeek(moment().year(moment().format('YYYY')).week());
        }

        setSelectedDateAnaTeamsRange('Custom Date Range');
        break;
      default:
        setFieldValue('fromDate', moment().format('YYYY-MM-DD'));
        setFieldValue('toDate', moment().format('YYYY-MM-DD'));
        break;
    }
  };

  const handleFilterByChange = (event) => {

    // Resetting remaining fields
    // setFieldValue('scoreCard', '');
    setFieldValue('group', '');
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('scoreCardCategory', '');
    setFieldValue('evaluator', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('section', '');
    setFieldValue('evaluator', '');

    const filterBy = event.target.value;
    switch (filterBy) {
      case 'Score Date':
        setFieldValue('filterByRange', 'Score Date');
        setFieldValue('filterBy', 'created_at');
        setSelectedTeamsFilterBy('Score Date');
        setSelectedTeamsFilterByValue('created_at')
        break;
      case 'Event Date':
        setFieldValue('filterByRange', 'Event Date');
        setFieldValue('filterBy', 'event_date');
        setSelectedTeamsFilterBy('Event Date');
        setSelectedTeamsFilterByValue('event_date')
        break;
      case 'Last Edit Date':
        setFieldValue('filterByRange', 'Last Edit Date');
        setFieldValue('filterBy', 'updated_at');
        setSelectedTeamsFilterBy('Last Edit Date');
        setSelectedTeamsFilterByValue('updated_at')
        break;
      default:
        setFieldValue('filterByRange', 'Last Edit Date');
        setFieldValue('filterBy', 'updated_at');
        setSelectedTeamsFilterBy('updated_at');
        setSelectedTeamsFilterByValue('updated_at')
        break;
    }

  };

  const handleOpenGroupFields = async () => {

    const groupFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    updateState('openGroupField', true)
    await getScoreLogGroups(groupFilterObj);

  };

  const handleGroupChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('highlightValue', '');
    setFieldValue('scoreCard', '');
    setFieldValue('multipleScoreCard', []);

    setFieldValue('group', newVal?.id ?? '');
    setFieldValue('groupField', newVal)
    // setSelectedTeamsGroupFilter(newVal?.id ?? '');

    // redux state fields
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("staffField", '');
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
  };

  const handleOpenTeamFields = () => {
    updateState('openTeamField', true)

    const teamFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogTeams(teamFilterObj)
  }

  const handleTeamChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue("multipleScoreCard", []);
    setFieldValue("singleScoreCard", '');
    setFieldValue('supervisor', '');

    // setSelectedTeamFilterDialog(event.target.value);
    setFieldValue("teams", newVal?.id);
  };

  const handleOpenSupervisorField = () => {
    updateState('openSupervisorField', true)
    const supFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.singleScoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": '',
      "staff": values.staff || '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": values.highlightValue || '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogSupervisor(supFilterObj);
  }

  const handleSupervisorChange = (event, newVal) => {
    setFieldValue("supervisor", newVal?.supervisor);

    setFieldValue("supervisorField", newVal);
    // setSelectedTeamsSupervisorFilter(event.target.value);
  };

  const handleOpenEventTypeField = () => {
    updateState('openEventTypeField', true)
    const evntTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.singleScoreCard,
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogEventType(evntTypeFilterObj);

  }
  const handleEventTypeChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('eventType', newVal?.eventType);
    // setSelectedTeamsEventFilter(event.target.value);

    // redux state fields
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
  };

  const handleOpenEventSubTypeField = () => {
    updateState('openEventSubTypeField', true)
    const evntSubTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.singleScoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogEventSubType(evntSubTypeFilterObj);

  }
  const handleEventSubTypeChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue('eventTypeEventSubType', newVal?.eventSubType);
    // redux state fields
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffField", '');

    // setSelectedTeamsEventSubTypeFilter(event.target.value);
  };

  const handleAdvancedFilters = (event) => {
    setAdvanceFilters((advanceFilters) => !advanceFilters);
  };


  const handleOpenMultiScorecardFields = async () => {
    updateState('openMultiScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }

  const handleMultiScorecardChange = (event, newValue) => {
    // Resetting remaining fields
    setFieldValue('eventType', '');
    setFieldValue('eventTypeEventSubType', '');
    setFieldValue('staff', '');
    setFieldValue('supervisor', '');
    setFieldValue('highlightValue', '');
    setFieldValue('dataTag', []);
    // setDataTagByScoreCard([]);
    // localStorage.setItem('selectedDataTag', JSON.stringify([]))
    // setselectedDataTagFilter([])

    const value = []
    const allValue = [];
    newValue?.map(option => {
      value.push(option?.scoreCard)
      allValue.push(option)
      return 0
    });

    setFieldValue("multiScorecardField", allValue)
    setFieldValue("singleScorecardField", allValue?.length > 0 ? allValue[0] : {})

    setFieldValue("multipleScoreCard", value ?? []);
    setFieldValue("singleScoreCard", value?.length > 0 ? value[0] : '');
    // setSingleScoreCard(value?.length > 0 ? value[0] : '')

    // setMultipleScoreCard(value ?? []);
    // setselectedScFilter(value?.length > 0 ? value[0] : '');

    // if (subModLabel === 4.7) {
    const filterScoreCardObj = {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "scoreCard": value ?? '',
    }
    getDataTagsByScoreCard(filterScoreCardObj)
    // }
  };

  const handleOpenSingleScorecardFields = async () => {
    updateState('openSingleScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }

  const handleSingleScorecardChange = (event, newValue) => {
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');

    setFieldValue('singleScoreCard', newValue?.scoreCard ?? '')
    setFieldValue("multipleScoreCard", [newValue?.scoreCard] ?? []);

    // localStorage.setItem('selectedDataTagValue', JSON.stringify([]))

    setFieldValue("dataTag", []);
    setselectedDataTag([])
    // setMultipleScoreCard([newValue?.scoreCard] ?? []);

    // setSingleScoreCard(newValue?.scoreCard ?? '')

    setFieldValue('singleScorecardField', newValue)
    setFieldValue("multiScorecardField", [newValue] ?? [])
    // localStorage.setItem('selectedDataTagValue', JSON.stringify([]))

    setFieldValue("dataTag", []);

    // redux state fields
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });

    // setSelectedScoreCardSingle(newValue?.scoreCard ?? '')
    const filterScoreCardObj = {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy || 'created_at',
      "scoreCard": newValue?.scoreCard !== '' ? newValue?.scoreCard : '',
    }
    getDataTagsByScoreCard(filterScoreCardObj)
  }

  const handleOpenStaffFields = () => {
    updateState('openStaffField', true)
    const empFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.singleScoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id) : ''
    }
    getScoreLogEmployee(empFilterObj);

  }

  const handleStaffChange = (event, newVal) => {
    setFieldValue('staff', newVal?.staff)

    setFieldValue('staffField', newVal)
    setFieldValue("highlightValue", '');
    // setSelectedTeamStaffFilter(event.target.value);
  };

  const handleOpenSectionField = () => {
    updateState('openSectionField', true)
    // if(values?.scoreCardSingle) {
    getSectionDropdown(values?.singleScoreCard);
    // }
  }

  const handleSectionField = (event, newVal) => {

    setFieldValue('section', newVal?.id)
    setFieldValue('sectionField', newVal)
    // setSelectedSelectionFilter(event.target.value)

  }
  const handleHighlightChange = (event) => {
    setFieldValue('highlightValue', event.target.value);
    setSelectedTeamsHighlight(event.target.value)
  };

  // const renderOptions = (props, option) => {
  //   return <li {...props} key={option?.scoreCard} style={{ color: option?.scoreCardIsArchive ? 'red' : '' }}>
  //     {option?.scoreCardName}
  //   </li>
  // }
  console.log('errore', errors, values)

  const renderOptions = (props, option) => {
    return <li {...props} key={option?.scoreCard} style={{ color: option?.scoreCardIsArchive ? 'red' : '' }}>
      {loadingState?.scorecardLoading ? 'Loading...' : option?.scoreCardName}
    </li>

  }

  const renderGroupOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.groupLoading ? option?.name : 'Loading...'}
    </li>
  }

  const renderTeamOptions = (props, option) => {
    // console.log('props & option', props, option, loadingState)
    return <li {...props} key={option?.id}>
      {!loadingState?.teamLoading ? option?.name : 'Loading...'}
    </li>
  }

  const renderEventOptions = (props, option) => {
    // console.log('option====>', option, props)
    return <li {...props} key={option?.eventType}>
      {
        loadingState?.eventTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.eventTypeEventType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }


  const renderEventSubOptions = (props, option) => {
    // console.log('option====>213', option, props)
    return <li {...props} key={option?.eventSubType}>
      {
        loadingState?.eventSubTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.subType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }

  const renderSupervisorOptions = (props, option) => {
    return <li {...props} key={option?.supervisor}>
      {!loadingState?.supervisorLoading ? `${option.supervisorUserFirstName} ${option.supervisorUserLastName}` : 'Loading...'}
    </li>
  }

  const renderStaffOptions = (props, option) => {
    return <li {...props} key={option?.supervisor}>
      {!loadingState?.staffLoading ? `${option.staffUserFirstName} ${option.staffUserLastName}` : 'Loading...'}
    </li>
  }

  const renderSectionOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.sectionLoading ? option?.name ?? '--' : 'Loading...'}
    </li>
  }

  const renderQuestionOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.questionLoading ? option?.question : 'Loading...'}
    </li>
  }
  return (
    <div>
      {addUserButton && (
        <Button variant="contained" onClick={handleClickOpen} className="halloween-animation">
          Filter
        </Button>
      )}

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <DialogTitle sx={{ pb: 2 }}>
              {' '}
              <h3>Analytics Report Filter </h3>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500]
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ paddingTop: '20px' }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ p: 0 }}>
                  <FormControl fullWidth />

                  <FormControl fullWidth>
                    <Button
                      startIcon={advanceFilters ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      sx={{ p: 0 }}
                      onClick={handleAdvancedFilters}
                    >
                      {' '}
                      {advanceFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'}{' '}
                    </Button>
                  </FormControl>
                </Stack>
                <Divider />

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel id="date-range-label">Date Range</InputLabel>
                    <Select
                      labelId="date-range-label"
                      id="demo-select-small"
                      value={values.dateRange}
                      label="Date Range"
                      {...getFieldProps('dateRange')}
                      onChange={(e) => {
                        handleDateRangeChange(e);
                      }}
                    >
                      {dateRange?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.dateRange}>
                          {item.dateRange}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="filter-by-label">Filter By</InputLabel>
                    <Select
                      defaultValue="Score Date"
                      labelId="filter-by-label"
                      id="demo-select-small"
                      value={values.filterByRange}
                      label="Filter By"
                      {...getFieldProps('filterByRange')}
                      onChange={handleFilterByChange}
                    >
                      {filterBy?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.type}>
                          {item.type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>

                {customFilters && (
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Box sx={{ width: '50%' }}>
                        <DesktopDatePicker
                          label="Date From"
                          inputFormat="yyyy/MM/dd"
                          name="eventDate"
                          minDate={new Date(dataCreatedFrom)}
                          disableFuture
                          {...getFieldProps('fromDate')}
                          onChange={(newValue) => {
                            setFieldValue("fromDate", newValue);
                            setFieldValue("fromweekValue", getWeekDay(moment(newValue).format('YYYY-MM-DD')))
                            setSelectedTeamsFromDate(newValue);

                            if (moment(newValue).format('MM-DD') === '01-01') {
                              formik.setFieldValue("fromWeek", 1)
                              setSelectedTeamsFromWeek(1)
                            } else {
                              formik.setFieldValue("fromWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                              setSelectedTeamsFromWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                            }

                            if (moment(newValue, "YYYY-MM-DD").isAfter(formik.values.toDate)) {
                              formik.setFieldValue("toDate", moment(newValue).format('YYYY-MM-DD'))
                              if (moment(newValue).format('MM-DD') === '01-01') {
                                formik.setFieldValue("toWeek", 1)
                                setSelectedTeamsToWeek(1)

                              } else {
                                formik.setFieldValue("toWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                                setSelectedTeamsToWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
                              }

                            }

                          }}

                          renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                        {formik.errors.eventDate && formik.touched.eventDate && (
                          <Typography variant="caption" sx={{ color: 'red', ml: 1 }}>
                            {formik.errors.eventDate}
                          </Typography>
                        )}

                      </Box>

                      <Box sx={{ width: '50%' }}>
                        <DesktopDatePicker
                          label="Date To"
                          inputFormat="yyyy/MM/dd"
                          name="eventDate"
                          minDate={new Date(dataCreatedFrom)}
                          disableFuture
                          {...getFieldProps('toDate')}
                          onChange={(newValue) => {
                            setFieldValue('toDate', newValue);
                            setSelectedTeamsToDate(newValue);

                            if (moment(newValue).format('MM-DD') === '01-01') {
                              formik.setFieldValue("toWeek", 1)
                              setSelectedTeamsToWeek(1)
                            } else {
                              formik.setFieldValue("toWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                              setSelectedTeamsToWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
                            }

                            // Extract year from full date
                            const fullDate = moment(newValue);
                            const extractyear = fullDate.year();

                            if (moment(newValue, "YYYY-MM-DD").isBefore(formik.values.fromDate) && /^\d{4}$/.test(extractyear)) {
                              formik.setFieldValue("fromDate", moment(newValue).format('YYYY-MM-DD'))
                              if (moment(newValue).format('MM-DD') === '01-01') {
                                formik.setFieldValue("fromWeek", 1)
                                setSelectedTeamsFromWeek(1)

                              } else {
                                formik.setFieldValue("fromWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
                                setSelectedTeamsFromWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
                              }

                            }

                          }}
                          renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                        {formik.errors.eventDate && formik.touched.eventDate && (
                          <Typography variant="caption" sx={{ color: 'red', ml: 1 }}>
                            {formik.errors.eventDate}
                          </Typography>
                        )}

                      </Box>
                    </Stack>
                  </LocalizationProvider>
                )}

                {customFilters && <Stack direction="row" sx={{ width: "100%", mb: 2 }} spacing={2}>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      required
                      value={formik.values.fromWeek}
                      multiple={false}
                      select
                      name="fromWeek"
                      onChange={(e) => {
                        moment.updateLocale('en', {
                          week: {
                            dow: 1
                          }
                        });
                        formik.setFieldValue("fromWeek", e.target.value);
                        setSelectedTeamsFromWeek(e.target.value);
                        setSelectedTeamsFromDate(moment().week(e.target.value).startOf('week'));
                        formik.setFieldValue("fromDate", moment().week(e.target.value).startOf('week'));
                      }}

                    >
                      {fromWeekNo?.map((item) => (
                        <MenuItem key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}

                    </TextField>
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      multiple={false}
                      value={formik.values.toWeek}
                      required
                      select
                      name="toWeek"
                      onChange={(e) => {
                        moment.updateLocale('en', {
                          week: {
                            dow: 1
                          }
                        });
                        formik.setFieldValue("toWeek", e.target.value);
                        setSelectedTeamsToWeek(e.target.value);
                        setSelectedTeamsToDate(moment().week(e.target.value).endOf('week'));
                        formik.setFieldValue("toDate", moment().week(e.target.value).endOf('week'));
                      }}

                    >
                      {toWeekNo?.map((item) => (
                        <MenuItem disabled={formik.values.fromWeek > item} key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}
                    </TextField>
                  </Box>

                </Stack>}

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>

                    <Autocomplete
                      fullWidth
                      open={state?.openGroupField}
                      onOpen={handleOpenGroupFields}
                      onClose={handleCloseFields}
                      // value={selectedGroup ?? null}
                      value={(() => {
                        if (reportsScoreLogGroups) {
                          return reportsScoreLogGroups?.find((option) => option?.id === values?.group);
                        }
                        // If API not loaded

                        return values.groupField;

                      })()}
                      options={
                        (() => {
                          if (reportsScoreLogGroups) {

                            return reportsScoreLogGroups;
                          }

                          return [values.groupField];
                        })()
                      }
                      // options={groupOptions}
                      getOptionLabel={(option) => option?.name || ""}
                      renderOption={renderGroupOptions}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(event, newValue) => {
                        handleGroupChange(event, newValue);
                      }}
                      id="controllable-states-demo"
                      name="group"
                      renderInput={(params) => <TextField {...params} label="Group"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                        error={Boolean(touched.group && errors.group)}
                        helperText={touched.group && errors.group}
                        required
                      />}
                    />
                  </FormControl>

                  {(subModLabel === 5.4) && <FormControl fullWidth>

                    <Autocomplete
                      fullWidth
                      open={state?.openTeamField}
                      onOpen={handleOpenTeamFields}
                      onClose={handleCloseFields}
                      value={
                        reportsScoreLogTeams ?
                          ([{
                            name: 'All', id: ''
                          }].concat(reportsScoreLogTeams))?.find((option) => option?.id === values?.teams)
                          :
                          values?.teamField ?? null
                      }
                      options={
                        (() => {
                          if (reportsScoreLogTeams) return [{ name: 'All', id: '' }, ...reportsScoreLogTeams];

                          // If API not loaded
                          if (values?.teamField) return [values.teamField];

                          return [{}];
                        })()
                      }
                      getOptionLabel={(option) => option?.name || ""}
                      renderOption={renderTeamOptions}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(e, newVal) => handleTeamChange(e, newVal)}
                      renderInput={(params) =>
                        <TextField {...params} label="Teams"
                          popoverProps={{
                            style: {
                              bottom: 0,
                              overflowY: 'auto'
                            }
                          }}
                          variant="outlined"

                        />}

                    />
                  </FormControl>
                  }
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {(subModLabel === 5.3) && <FormControl fullWidth>
                    <Autocomplete
                      open={state?.openSingleScorecardField}
                      onOpen={handleOpenSingleScorecardFields}
                      onClose={handleCloseFields}
                      fullWidth
                      value={reportsScoreLogScorecards ?
                        reportsScoreLogScorecards?.find((option) => option?.scoreCard === values?.singleScoreCard) :
                        values?.singleScorecardField ?? null
                      }

                      options={reportsScoreLogScorecards ?? [{}]}
                      getOptionLabel={(option) => option?.scoreCardName || ""}
                      renderOption={renderOptions}
                      onChange={(event, newValue) => {
                        handleSingleScorecardChange(event, newValue)

                      }}
                      isOptionEqualToValue={(option, value) => {
                        // console.log('option & value', option, value)
                        let equalOptions
                        if (option?.scoreCard) {
                          equalOptions = option?.scoreCard === value?.scoreCard
                        } else {
                          equalOptions = filterFieldsData?.singleScorecardField?.scoreCard === value?.scoreCard
                        }
                        return equalOptions
                      }}
                      id="controllable-states-demo"
                      renderInput={(params) => <TextField {...params} label="Scorecard"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        error={subModLabel === 1.11 ? Boolean((touched.singleScoreCard && errors.singleScoreCard)) : ((values?.singleScoreCard === '') && true)}
                        helperText={subModLabel === 1.11 ? (touched.singleScoreCard && errors.singleScoreCard) : (values?.singleScoreCard === '') && 'This value is required'}
                        variant="outlined"
                        // error={Boolean((touched.scoreCardSingle && errors.scoreCardSingle))}
                        // helperText={(touched.scoreCardSingle && errors.scoreCardSingle)}
                        required
                        onBlur={formik.handleBlur}

                      />}
                    />
                    {/* <Autocomplete
                      value={(reportsScoreLogScorecards)?.find((option) => {
                        return option?.scoreCard === (singleScoreCard || values?.singleScoreCard)
                      }
                      )}

                      fullWidth
                      options={reportsScoreLogScorecards}
                      getOptionLabel={(option) => option?.scoreCardName || ""}
                      renderOption={renderOptions}
                      onChange={(event, newValue) => {
                        setFieldValue("eventType", '');
                        setFieldValue("eventTypeEventSubType", '');
                        setFieldValue("staff", '');
                        setFieldValue("highlightValue", '');
                        setFieldValue("section", '');

                        setFieldValue('singleScoreCard', newValue?.scoreCard ?? '')
                        setFieldValue("multipleScoreCard", [newValue?.scoreCard] ?? []);

                        // localStorage.setItem('selectedDataTagValue', JSON.stringify([]))

                        setFieldValue("dataTag", []);
                        setselectedDataTag([])
                        setMultipleScoreCard([newValue?.scoreCard] ?? []);

                        setSingleScoreCard(newValue?.scoreCard ?? '')
                        const filterScoreCardObj = {
                          "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
                          "toDate": moment(values.toDate).format('YYYY-MM-DD'),
                          "filterBy": values.filterBy || 'created_at',
                          "scoreCard": newValue?.scoreCard !== '' ? newValue?.scoreCard : '',
                        }
                        getDataTagsByScoreCard(filterScoreCardObj)

                      }}
                      id="controllable-states-demo"
                      renderInput={(params) => <TextField {...params} label="Scorecard"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        error={((values?.singleScoreCard === '') && true)}
                        helperText={(values?.singleScoreCard === '') && 'This value is required'}
                        variant="outlined"
                        // error={Boolean((touched.singleScoreCard && errors.singleScoreCard))}
                        // helperText={(touched.singleScoreCard && errors.singleScoreCard)}
                        required
                        onBlur={formik.handleBlur}

                      />}
                    /> */}
                  </FormControl>

                  }
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {(subModLabel === 5.4) && <FormControl fullWidth>
                    {/* <Autocomplete
                      multiple
                      freeSolo
                      value={reportsScoreLogScorecards?.filter((option) => {
                        return values?.multipleScoreCard?.includes(option?.scoreCard)
                      })}
                      fullWidth
                      options={reportsScoreLogScorecards}
                      getOptionLabel={(option) => option?.scoreCardName || ""}
                      renderOption={renderOptions}
                      onChange={(event, newValue) => {
                        handleScorecardMultipleChange(event, newValue);
                      }}

                      id="controllable-states-demo"
                      isOptionEqualToValue={(option, value) => option?.scoreCard === value?.scoreCard}
                      renderTags={(value, getTagProps) => {
                        return value.map((option, index) => (
                          <Chip
                            variant="outlined"
                            label={typeof option === "string" ? option : option?.scoreCardName}
                            {...getTagProps({ index })}
                          />
                        ));
                      }}
                      renderInput={(params) => <TextField {...params} label="Scorecard"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto',

                          }
                        }}
                        variant="outlined"
                        required
                        // value={selectedScMultipleFilter}
                        name='multipleScoreCard'
                        {...getFieldProps('multipleScoreCard')}
                        error={Boolean(touched.multipleScoreCard && errors.multipleScoreCard)}
                      // helperText={touched.multipleScoreCard && errors.multipleScoreCard}
                      />}
                    /> */}
                    <Autocomplete
                      multiple
                      freeSolo
                      open={state?.openMultiScorecardField}
                      onOpen={handleOpenMultiScorecardFields}
                      onClose={handleCloseFields}
                      // value={reportsScoreLogScorecards?.filter((option) => values?.scoreCard?.includes(option?.scoreCard))}
                      value={
                        reportsScoreLogScorecards
                          ? reportsScoreLogScorecards?.filter((option) =>
                            values?.multipleScoreCard?.includes(option?.scoreCard)
                          )
                          : values?.multiScorecardField?.filter((option) =>
                            values?.multipleScoreCard?.includes(option?.scoreCard)
                          ) || []
                      }
                      name='scoreCard'
                      fullWidth
                      options={reportsScoreLogScorecards ?? []}
                      getOptionLabel={(option) => option?.scoreCardName || ""}
                      renderOption={renderOptions}
                      onChange={(event, newValue) => {
                        handleMultiScorecardChange(event, newValue);
                      }}
                      id="controllable-states-demo"
                      isOptionEqualToValue={(option, value) => option?.scoreCard === value?.scoreCard}
                      renderTags={(value, getTagProps) => {
                        return value.map((option, index) => (
                          <Chip
                            variant="outlined"
                            label={typeof option === "string" ? option : option?.scoreCardName}
                            {...getTagProps({ index })}
                          />
                        ));
                      }}
                      renderInput={(params) => <TextField {...params} label="Scorecard"
                        popoverProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto',
                          }
                        }}
                        variant="outlined"
                        error={((values?.multipleScoreCard?.length === 0) && true)}
                        helperText={(values?.multipleScoreCard?.length === 0) && 'This value is required'}
                        onBlur={formik.handleBlur}
                        required
                      />}

                    />
                    {/* {(touched.multipleScoreCard && errors.multipleScoreCard) ?
                      // {(errors.multipleScoreCard) ?
                      <Typography sx={{ color: 'red', pl: 1, fontSize: '12px', p: 1 }}>
                        This value is required
                      </Typography>
                      : null} */}
                  </FormControl>}


                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    {/* <InputLabel shrink id="group-label">
                      Event Type
                    </InputLabel>
                    <Select
                      labelId="group-label"
                      id="demo-select-small"
                      displayEmpty
                      input={<OutlinedInput notched label="Event Type" />}
                      {...getFieldProps('eventType')}
                      onChange={handleEventTypeChange}
                    >
                      <MenuItem value=""> All </MenuItem>
                      {reportsScoreLogEventType?.map((item) => (
                        <MenuItem key={item.eventType} id={item.eventType} value={item.eventType}>
                          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{item.eventTypeEventType}</Typography>&nbsp;<Typography sx={{ display: 'inline-block', fontStyle: 'italic', fontSize: '12px', fontWeight: 'bold' }}>{`(${item?.scorecard})`}</Typography>
                        </MenuItem>
                      ))}
                    </Select> */}
                    <Autocomplete
                      open={state?.openEventTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventTypeField}
                      value={
                        reportsScoreLogEventType ? ([{
                          eventType: '',
                          eventTypeEventType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventType))?.find((options) => options?.eventType === values?.eventType)
                          : values?.eventField ?? null
                      }
                      options={reportsScoreLogEventType ? ([{
                        eventType: '',
                        eventTypeEventType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventType)) : [values?.eventField]}
                      getOptionLabel={(option) =>
                        option?.eventTypeEventType
                          ? `${option.eventTypeEventType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventOptions}

                      onChange={(e, newVal) => handleEventTypeChange(e, newVal)}
                      isOptionEqualToValue={(option, value) => {
                        // console.log('option & value', option, value)
                        let equalOptions
                        if (option?.eventType) {
                          equalOptions = option?.eventType === value?.eventType
                        } else {
                          equalOptions = filterFieldsData?.eventField?.eventType === value?.eventType
                        }
                        return equalOptions
                      }}
                      renderInput={(params) => <TextField {...params} label="Event Type"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />
                      }

                    />
                  </FormControl>

                  <FormControl fullWidth>
                    {/* <InputLabel shrink id="teams-label">
                      Event Sub Type
                    </InputLabel>
                    <Select
                      labelId="teams-label"
                      id="demo-select-small"
                      displayEmpty
                      input={<OutlinedInput notched label="Event Sub Type" />}
                      {...getFieldProps('eventTypeEventSubType')}
                      onChange={handleEventSubTypeChange}
                    >
                      <MenuItem value=""> All </MenuItem>
                      {reportsScoreLogEventSubType?.map(
                        (item, index) =>
                          item?.eventSubType &&
                          item.eventTypeEventSubType && (
                            <MenuItem key={index} id={item.eventSubType} value={item.eventSubType}>
                              <Typography sx={{ fontSize: '14px', display: 'inline' }}>{item.eventTypeEventSubType}</Typography>&nbsp;<Typography sx={{ display: 'inline-block', fontStyle: 'italic', fontSize: '12px', fontWeight: 'bold' }}>{`(${item?.scorecard})`}</Typography>
                            </MenuItem>
                          )
                      )}
                    </Select> */}
                    <Autocomplete
                      open={state?.openEventSubTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventSubTypeField}
                      value={
                        reportsScoreLogEventSubType ? (([{
                          eventSubType: '',
                          subType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventSubType))?.find((options) => options?.eventSubType === values?.eventTypeEventSubType))
                          : values?.eventSubField
                      }
                      options={reportsScoreLogEventSubType ? ([{
                        eventSubType: '',
                        subType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventSubType)) : [values?.eventSubField]}
                      getOptionLabel={(option) =>
                        option?.subType || option?.scorecard
                          ? `${option.subType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventSubOptions}

                      onChange={(e, newVal) => handleEventSubTypeChange(e, newVal)}
                      // isOptionEqualToValue={(option, value) => option?.eventSubType === value?.eventSubType}
                      isOptionEqualToValue={(option, value) => {
                        // console.log('option & value', option, value)
                        let equalOptions
                        if (option?.eventType) {
                          equalOptions = option?.eventSubType === value?.eventSubType
                        } else {
                          equalOptions = filterFieldsData?.eventSubField?.eventSubType === value?.eventSubType
                        }
                        return equalOptions
                      }}
                      renderInput={(params) => <TextField {...params} label="Event Sub Type"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />
                      }
                    />
                  </FormControl>
                </Stack>
                {(subModLabel === 5.3) &&
                  <FormControl sx={{ width: "100%" }}>
                    {/* <InputLabel shrink id="scorecard-label" required>Employee</InputLabel>
                    <Select
                      labelId="scorecard-label"
                      id="demo-select-small"
                      // displayEmpty
                      required
                      input={<OutlinedInput notched label="employee" />}
                      error={Boolean(touched.staff && errors.staff)}
                      helperText={touched.staff && errors.staff}
                      value={values?.staff}
                      {...getFieldProps('staff')}
                      onChange={handleStaffChange}
                    >
                      {reportsScoreLogEmployee?.map((item) => (
                        <MenuItem key={item.staff} id={item.staff} value={item.staff}>
                          {`${item.staffUserFirstName} ${item.staffUserLastName}`}
                        </MenuItem >
                      ))}
                    </Select> */}
                    <Autocomplete
                      fullWidth
                      open={state?.openStaffField}
                      onOpen={handleOpenStaffFields}
                      onClose={handleCloseFields}
                      value={(() => {
                        if (reportsScoreLogEmployee) {
                          return reportsScoreLogEmployee?.find((option) => option?.staff === values?.staff)
                        }

                        // if not API loaded and not with "All" value staff fields
                        if (values?.staffField) {
                          return values?.staffField
                        }

                        return ''
                      })()}

                      options={(() => {
                        if (reportsScoreLogEmployee) return reportsScoreLogEmployee

                        // if not API loaded and not with "All" value staff fields
                        if (values?.staffField) {
                          return [values?.staffField]
                        }
                        return []
                      })()}

                      getOptionLabel={(option) =>
                        option?.staffUserFirstName || option?.staffUserLastName
                          ? `${option.staffUserFirstName} ${option.staffUserLastName}`
                          : ''
                      }
                      renderOption={renderStaffOptions}
                      isOptionEqualToValue={(option, value) => option?.staff === value?.staff}
                      onChange={(e, newVal) => {
                        handleStaffChange(e, newVal)
                      }
                      }
                      renderInput={(params) =>
                        <TextField {...params} label="Employee"
                          popoverProps={{
                            style: {
                              bottom: 0,
                              overflowY: 'auto'
                            }
                          }}
                          variant="outlined"
                          error={Boolean(touched.staff && errors.staff)}
                          helperText={touched.staff && errors.staff}
                          required
                        />}

                    />
                    {/* {formik.errors.staff && formik.touched.staff ? <Typography sx={{ color: 'red', pl: 1, fontSize: '12px', p: 1 }}>{formik.errors.staff}</Typography> : null} */}
                  </FormControl>
                }
                {
                  <FormControl fullWidth>
                    {advanceFilters && (subModLabel === 5.3) && <FormControl>
                      {/* <InputLabel shrink id="scorecard-label">Sections</InputLabel>
                      <Select
                        defaultValue='All'
                        labelId="scorecard-label"
                        id="demo-select-small"
                        displayEmpty
                        input={<OutlinedInput notched label="Sections" />}
                        onChange={handleSectionField}
                        // error={Boolean(touched.userLev && errors.userLev)}
                        // helperText={touched.userLev && errors.userLev}
                        {...getFieldProps("section")}
                      >
                        <MenuItem value=""> All </MenuItem >
                        {scorecardSection?.map((item) => (
                          <MenuItem key={item.id} id={item.id} value={item.id}>
                            {item.name}
                          </MenuItem >
                        ))}
                      </Select> */}
                      <Autocomplete
                        open={state?.openSectionField}
                        onClose={handleCloseFields}
                        onOpen={handleOpenSectionField}
                        value={
                          scorecardSection ? ([{
                            id: '',
                            name: 'All',
                            scoreCard: '',
                            type: ''
                          }].concat(scorecardSection))?.find((options) => options?.id === values?.section)
                            : values?.sectionField ?? null
                        }
                        options={scorecardSection ? ([{
                          id: '',
                          name: 'All',
                          scoreCard: '',
                          type: ''
                        }].concat(scorecardSection)) : [values?.sectionField]}
                        getOptionLabel={(option) =>
                          option?.name
                        }
                        renderOption={renderSectionOptions}

                        onChange={(e, newVal) => handleSectionField(e, newVal)}
                        isOptionEqualToValue={(option, value) => {
                          let equalOptions
                          if (option?.id) {
                            equalOptions = option?.id === value?.id
                          } else {
                            equalOptions = filterFieldsData?.sectionField?.id === value?.id
                          }
                          return equalOptions
                        }}
                        renderInput={(params) => <TextField {...params} label="Sections"
                          popoverprops={{
                            style: {
                              bottom: 0,
                              overflowY: 'auto'
                            }
                          }}
                          variant="outlined"
                        />
                        }

                      />
                    </FormControl>
                    }
                  </FormControl>
                }
                {
                  advanceFilters && (subModLabel === 5.4) && <FormControl fullWidth>
                    {/* <InputLabel shrink id="group-label">Supervisor</InputLabel>
                    <Select
                      // defaultValue='All'
                      labelId="group-label"
                      id="demo-select-small"
                      displayEmpty
                      value={values.supervisor}
                      // label="Supervisor"
                      input={<OutlinedInput notched label="Supervisor" />}
                      {...getFieldProps('supervisor')}
                      onChange={handleSupervisorChange}
                    >
                      <MenuItem value=""> All </MenuItem >
                      {reportsScoreLogSupervisor?.map((item) => (
                        <MenuItem key={item.supervisor} id={item.supervisor} value={item.supervisor}>
                          {`${item.supervisorUserFirstName} ${item.supervisorUserLastName}`}
                        </MenuItem >
                      ))}
                    </Select> */}
                    <Autocomplete
                      open={state?.openSupervisorField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenSupervisorField}
                      // value={values.supervisor}
                      value={
                        reportsScoreLogSupervisor ?
                          ([{
                            supervisorUserFirstName: 'All',
                            supervisorUserLastName: '',
                            supervisor: ''
                          }].concat(reportsScoreLogSupervisor))?.find((option) => option?.supervisor === values?.supervisor)
                          :
                          values?.supervisorField ?? null
                      }
                      options={
                        (() => {
                          if (reportsScoreLogSupervisor) return [{ supervisorUserFirstName: 'All', supervisorUserLastName: '', supervisor: '' }, ...reportsScoreLogSupervisor];

                          // If API not call
                          if (values?.supervisorField) return [values.supervisorField];

                          return [{}];
                        })()
                      }
                      getOptionLabel={(option) => `${option.supervisorUserFirstName} ${option.supervisorUserLastName}` || ""}
                      renderOption={renderSupervisorOptions}

                      onChange={(e, newVal) => handleSupervisorChange(e, newVal)}
                      isOptionEqualToValue={(option, value) => option?.supervisor === value?.supervisor}

                      renderInput={(params) => <TextField {...params} label="Supervisor"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />
                      }

                    />
                  </FormControl>
                }
                {advanceFilters && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      type='number'
                      label="Highlight Below"
                      value={values.highlightBelow}
                      {...getFieldProps('highlightValue')}
                      error={Boolean(touched.highlightValue && errors.highlightValue)}
                      helperText={touched.highlightValue && errors.highlightValue}
                      onChange={handleHighlightChange}
                    />
                  </FormControl>
                  {
                    (subModLabel === 5.4 || subModLabel === 5.3) &&
                    <FormControl fullWidth>
                      <InputLabel shrink id="group-label">Formula</InputLabel>
                      <Select
                        labelId="group-label"
                        id="demo-select-small"
                        displayEmpty
                        value={values.formula}
                        input={<OutlinedInput notched label="Formula" />}
                        {...getFieldProps('formula')}
                      >
                        {formulaType?.map((item) => (
                          <MenuItem key={item.id} id={item.id} value={item?.id}>
                            {item.type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  }

                </Stack>}
                {/* comment for some time-- */}
                {/* {advanceFilters && subModLabel === 5.4 && (
                  <FormControlLabel
                    label="Numeric Values"
                    control={
                      <Checkbox
                        checked={values.numericValues}
                        {...getFieldProps('numericValues')}
                        size="small" />
                    }
                  />
                )} */}

              </Stack>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => {
                  handleClose();
                }}
                color="inherit"
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained" loading={isSubmitting}>
                Apply
              </Button>
            </DialogActions>
          </Form>
        </FormikProvider>
      </Dialog>
    </div>
  );
}